$(() => {
    initClickTabs();
});

function initClickTabs() {
    let url = window.location.href;

    if (url.includes('#general')) {
        $('#general-button').click();
    }

    if (url.includes('#promotions')) {
        $('#promotions-button').click();
    }
}
